import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout(props) {
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/logout')
      .then(response => response.json())
      .then(data => {
        if (data.success === 1) {
          props.onLogoutSuccess().then(() => {
            navigate('/login');
          });
        }
      })
  }, [props, navigate]);

  return (null);
}

export default Logout;
